export default __webpack_public_path__ + "static/media/users_image.82e62917.jpg";